// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"seoBlock_blockWrapper__NGGrB","seoTitle":"seoBlock_seoTitle__BM0yX","seoText":"seoBlock_seoText__zzJND","seoButton":"seoBlock_seoButton__muu2K"};